import { type FC } from 'react';
import type { ImpliedRealizedVolatilityProps } from './types';
import ImpliedRealizedVolatilityContent from './implied-realized-volatility-content';
import { Widget } from '../../widget';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';

const ImpliedRealizedVolatilityWidget: FC<ImpliedRealizedVolatilityProps> = (props) => {
  const { widget, actions } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <ImpliedRealizedVolatilityContent />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default ImpliedRealizedVolatilityWidget;
